export default __webpack_public_path__ + "static/media/onboarding-image.9668c242.jpg";